export default "__VITE_ASSET__BZ10uTEC__"